export enum IconSize {
  Large = '64px',
  Regular = '32px',
  Small = '16px',
  Mini = '12px',
  Tiny = '8px',
  Fit = '100%',
}
